import { b2Math, b2Vec2 } from "./math.js";

export class b2Settings {
  static USHRT_MAX = 65535;
  static b2_pi = Math.PI;
  static b2_maxManifoldPoints = 2;
  static b2_maxPolygonVertices = 20;
  static b2_maxProxies = 512;
  static b2_maxPairs = 8 * b2Settings.b2_maxProxies;
  static b2_linearSlop = 0.005;
  static b2_angularSlop = (2 / 180) * b2Settings.b2_pi;
  static b2_toiSlop = 8 * b2Settings.b2_linearSlop;
  static b2_maxTOIContactsPerIsland = 32;
  static b2_velocityThreshold = 1;
  static b2_maxLinearCorrection = 0.2;
  static b2_maxAngularCorrection = (8 / 180) * b2Settings.b2_pi;
  static b2_maxLinearVelocity = 200;
  static b2_maxLinearVelocitySquared = b2Settings.b2_maxLinearVelocity * b2Settings.b2_maxLinearVelocity;
  static b2_maxAngularVelocity = 250;
  static b2_maxAngularVelocitySquared = b2Settings.b2_maxAngularVelocity * b2Settings.b2_maxAngularVelocity;
  static b2_contactBaumgarte = 0.2;
  static b2_timeToSleep = 0.5;
  static b2_linearSleepTolerance = 0.01;
  static b2_angularSleepTolerance = 2 / 180;

  static b2Assert(condition) {
    if (!condition) {
      const crash = new b2Vec2();
      crash.x += 1;
    }
  }
}

export class b2Color {
  constructor(r, g, b) {
    this._r = 0;
    this._g = 0;
    this._b = 0;
    this.Set(r, g, b);
  }

  Set(r, g, b) {
    this._r = Math.trunc(255 * b2Math.b2Clamp(r, 0, 1));
    this._g = Math.trunc(255 * b2Math.b2Clamp(g, 0, 1));
    this._b = Math.trunc(255 * b2Math.b2Clamp(b, 0, 1));
  }

  set r(value) {
    this._r = Math.trunc(255 * b2Math.b2Clamp(value, 0, 1));
  }

  set g(value) {
    this._g = Math.trunc(255 * b2Math.b2Clamp(value, 0, 1));
  }

  set b(value) {
    this._b = Math.trunc(255 * b2Math.b2Clamp(value, 0, 1));
  }

  get color() {
    return this._r | (this._g << 8) | (this._b << 16);
  }
}
